let baseDomain = 'camping.info';

const baseDomainParts = process.env.VUE_APP_API_URL.split('.');
const baseDomainLength = baseDomainParts.length;

if (baseDomainLength > 2) {
  baseDomain = `${baseDomainParts[baseDomainLength - 2]}.${baseDomainParts[baseDomainLength - 1]}`;
}

const backend = new URLSearchParams(window.location.search).get('backend');

let detectedBackendUrl = process.env.VUE_APP_API_URL;
if (backend && backend.match(/^[a-z0-9_-]+$/i)) {
  detectedBackendUrl = `https://${backend}.${baseDomain}`;
}

const backendUrl = detectedBackendUrl;

export default backendUrl;
